import { Component, HostBinding, Input } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";

@Component({
	templateUrl: "./error-popup.component.html",
})
export class ErrorPopupComponent {
	@HostBinding("class.confirm") customClass = true;

	constructor(private dialog: DialogAdapter) {}

	@Input()
	keys!: {
		titleKey: string;
		message: string;
	};

	ok(): void {
		this.dialog.close("ok");
	}
}
